import React from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import UpgradeProgram from "../Components/Dashboard/Manage-My-Program/UpgradeProgram";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthUpgradeprogram = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <UpgradeProgram /> : <SessionTimeoutRedirect />
}
export default AuthUpgradeprogram;


